<template>
    <div class="m-profile-page">
      <div class="sticky-header">
        <FeedHeader />
      </div>
  
      <main class="m-profile-content">
        <button class="back-btn" @click="$router.back()">
          ← Назад
        </button>
  
        <section class="premium-wrapper">
          <PremiumSkeleton v-if="isLoading" />
  
          <PremiumActive
            v-else-if="premium && premium.isActive"
            :premium="premium"
            @renew="openPaywall"
          />
  
          <PremiumStub
            v-else
            @subscribe="openPaywall"
          />
        </section>
      </main>
  
      <teleport to="body">
        <Paywall
          v-if="showPaywall"
          @close="showPaywall = false"
        />
      </teleport>
  
      <MobileTabBar />
    </div>
  </template>
  
  <script setup>
  import { nextTick, onMounted, ref } from 'vue';
  
  import FeedHeader from '../FeedHeader.vue';
  import MobileTabBar from '../MobileTabBar2.vue';
  
  import PremiumService from '../../api/PremiumService';
  
  import PremiumStub from '../profile/PremiumStub.vue';
  import PremiumActive from '../profile/PremiumActive.vue';
  import PremiumSkeleton from '../profile/PremiumSkeleton.vue';
  
  import Paywall from '../../views/Paywall.vue';
  
  const premium = ref(null);
  const isLoading = ref(true);
  const showPaywall = ref(false);
  
  async function loadPremium() {
    isLoading.value = true;
  
    try {
      premium.value = await PremiumService.fetchMySubscription();
    } catch (e) {
      console.error('Ошибка загрузки подписки:', e);
      premium.value = null;
    } finally {
      setTimeout(() => {
        isLoading.value = false;
      }, 350);
    }
  }
  
  function openPaywall() {
    showPaywall.value = false;
  
    nextTick(() => {
      showPaywall.value = true;
    });
  }
  
  onMounted(() => {
    loadPremium();
  });
  </script>
  
  <style scoped>
  .m-profile-page {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    background: var(--background-color);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .sticky-header {
    flex-shrink: 0;
  }
  
  .m-profile-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
    padding-bottom: 96px;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
  }
  
  .back-btn {
    height: 36px;
    padding: 0 14px;
    margin-bottom: 14px;
    border: none;
    border-radius: 999px;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(8px);
    color: #111;
    font-size: 13px;
    font-family: "Eastman-Medium", sans-serif;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
  }
  
  [data-theme="dark"] .back-btn {
    background: rgba(40,40,40,0.92);
    color: #fff;
  }
  
  .premium-wrapper {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: all .25s ease;
  }
  
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(8px);
  }
  
  @media (min-width: 768px) {
    .m-profile-page {
      max-width: 430px;
      margin: 0 auto;
      border-left: 1px solid var(--separator_home);
      border-right: 1px solid var(--separator_home);
    }
  }
  </style>